import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>PASSION CARE 4 U</h3>
            <p className="footer-tagline">Consultancy & Training</p>
            <p className="footer-description">
              Delivering exceptional, client-centric training in specialized
              short courses at the advanced certificate level.
            </p>
          </div>

          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul className="footer-links">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/about">About Us</Link>
              </li>
              <li>
                <Link to="/services">Services</Link>
              </li>
              <li>
                <Link to="/contact">Contact Us</Link>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Courses</h4>
            <ul className="footer-links">
              <li>
                <Link to="/services">Care Giver</Link>
              </li>
              <li>
                <Link to="/services">Child Minder</Link>
              </li>
              <li>
                <Link to="/services">Farming</Link>
              </li>
              <li>
                <Link to="/services">Warehouse Packer</Link>
              </li>
              <li>
                <Link to="/services">Psycho Social Counselling</Link>
              </li>
              <li>
                <Link to="/services">HIV Management</Link>
              </li>
              <li>
                <Link to="/services">Beauty, Nails & Lahses</Link>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Contact Info</h4>
            <div className="contact-info">
              <div className="contact-item">
                {/* <span className="contact-label">Phone:</span>
                <a href="https://wa.me/+27786328699">+27 78 632 8699</a> */}
              </div>
              <div className="contact-item">
                <span className="contact-label">Phone:</span>
                <a href="https://wa.me/+260773393067">+260 773393067</a>
              </div>
              <div className="contact-item">
                <span className="contact-label">Email:</span>
                <a href="mailto:passioncare4uever@gmail.com">
                  info@passioncare4uglobal.com
                </a>
              </div>
              <div className="contact-item">
                <span className="contact-label">Website:</span>
                <a
                  href="https://passioncare4uglobal.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  passioncare4uglobal.com
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="copyright">
            &copy; {new Date().getFullYear()} PASSION CARE4U PTY LTD. All rights
            reserved.
          </div>
          <div className="footer-notes">
            <p>
              Online & Physical Learning | Community Voluntary Work | Global
              Training Online | Physical Training At Passion Care For You
              Offices
            </p>
          </div>

          <div className="footer-notes">
            <br />
            <br />
            <p>
              Developed by{" "}
              <a href="https://kafuetechnologies.com/" target="_blank">
                Kafue Technologies
              </a>{" "}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
